import yesNoModel from './yesNoModel';
import customValidator from '../validators/customValidator';

const healthModel = () => {
  return {
    sections: [
      {
        title: 'Health',
        rows: [
          {
            cols: [
              {
                label: 'Diagnosis',
                mapTo: 'healthDiagnosis',
                type: 'textarea',
                style: {
                  width: '757px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Does this individual have a history of seizures?',
                mapTo: 'hasHistoryOfSeizures',
                type: 'radio',
                options: yesNoModel().yesNo,
                inline: true,
                className: 'inline-radio-items'
              },
            ],
          },
          {
            cols: [
              {
                label: 'Allergies',
                mapTo: 'allergies',
                type: 'text',
                style: { width: '373px' },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Special dietary needs',
                mapTo: 'specialDietaryNeeds',
                type: 'text',
                style: { width: '373px' },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Mobility Needs',
                mapTo: 'mobilityNeedsId',
                type: 'radio',
                optionType: 'MobilityNeeds',
                includeOther: true,
                otherMapTo: 'mobilityNeedsOther',
                inline: true,
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                label: 'Is there a DNR/DNI for this individual?',
                mapTo: 'isDnrDniForIndividual',
                type: 'radio',
                options: yesNoModel().yesNo,
                inline: true,
                className: 'inline-radio-items'
              },
            ],
          },
          {
            cols: [
              {
                label: 'Medications',
                type: 'label',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Name of Medication',
                mapTo: 'medications[0].name',
                type: 'text',
                maxLength: 50,
              },
              {
                label: 'Purpose/Indication',
                mapTo: 'medications[0].purpose',
                type: 'text',
                maxLength: 50,
              },
              {
                label: 'Name of Medication',
                mapTo: 'medications[1].name',
                type: 'text',
                maxLength: 50,
              },
              {
                label: 'Purpose/Indication',
                mapTo: 'medications[1].purpose',
                type: 'text',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                mapTo: 'medications[2].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[2].purpose',
                maxLength: 50,
              },
              {
                mapTo: 'medications[3].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[3].purpose',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                mapTo: 'medications[4].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[4].purpose',
                maxLength: 50,
              },
              {
                mapTo: 'medications[5].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[5].purpose',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                mapTo: 'medications[6].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[6].purpose',
                maxLength: 50,
              },
              {
                mapTo: 'medications[7].name',
                type: 'text',
                maxLength: 50,
              },
              {
                type: 'text',
                mapTo: 'medications[7].purpose',
                maxLength: 50,
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'Does this person need medications administered while attending MRCI programs?',
                type: 'radio',
                mapTo: 'doesNeedMedicationsWhileMrci',
                options: yesNoModel().yesNo,
                inline: true,
                className: 'inline-radio-items'
              },
            ],
          },
          {
            cols: [
              {
                label:
                  'If MRCI is assigned responsibility for medication assistance or medication administration, MRCI will provide medication administration or assistance (including set up) according to the level indicated here',
                type: 'label',
              },
            ],
          },
          {
            cols: [
              {
                label: 'Medication Assistance',
                mapTo: 'medicationAssistance',
                type: 'text',
                maxLength: 200,
                style: { width: '373px' },
              },
              {
                label: 'Medication Administration',
                mapTo: 'medicationAdministration',
                type: 'text',
                maxLength: 200,
                style: { width: '373px' },
              },
            ],
          },
        ],
      },
      {
        title: 'Primary Emergency Contact',
        style: {
          marginTop: '15px',
        },
        rows: [
          {
            cols: [
              {
                type: 'label',
                label: '*Information copied from Legal Representative',
                style: {
                  color: 'black'
                },
                isVisible : (data) =>{
                  return  data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                }
              }
            ]
          },
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[3].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[3] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Primary Emergency Contact',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||
                      data.relationshipToClient ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[3].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[3] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Primary Emergency Contact',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||
                      data.relationshipToClient ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                }
              },
              {
                label: 'Relationship to Client',
                mapTo: 'contacts[3].relationshipToClient',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Cell Phone Number',
                mapTo: 'contacts[3].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[3].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                }
              },
              {
                label: 'E-mail',
                mapTo: 'contacts[3].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '273px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[0] && data.teamMembers[0].isEmergencyContact;
                }
              },
            ],
          },
        ],
      },
      {
        title: 'Secondary Emergency Contact',
        rows: [
          {
            cols: [
              {
                type: 'label',
                label: '*Information copied from Legal Representative',
                style: {
                  color: 'black'
                },
                isVisible : (data) =>{
                  return  data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                }
              }
            ]
          },
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[4].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[4] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Secondary Emergency Contact',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||  
                      data.relationshipToClient ||  
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[4].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[4] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Secondary Emergency Contact',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||  
                      data.relationshipToClient ||  
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                }
              },
              {
                label: 'Relationship to Client',
                mapTo: 'contacts[4].relationshipToClient',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Cell Phone Number',
                mapTo: 'contacts[4].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[4].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                }
              },
              {
                label: 'E-mail',
                mapTo: 'contacts[4].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '273px',
                },
                isDisabled : (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                },
                specialAsteriksVisibility: (data) => {
                  return data.teamMembers[1] && data.teamMembers[1].isEmergencyContact;
                }
              },
            ],
          },
        ],
      },

      {
        title: 'Preferred Hospital Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'Hospital Name',
                mapTo: 'contacts[5].name',
                type: 'text',
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[5] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Preferred Hospital Contact Information',
                    'Hospital Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.address ||  
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Address',
                mapTo: 'contacts[5].address',
                type: 'text',
                style: {
                  width: '373px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'contacts[5].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'State',
                mapTo: 'contacts[5].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'contacts[5].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[5].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ]
          },
        ]
      },
      {
        title: 'Health Care Provider Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[6].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[6] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Health Care Provider Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||  
                      data.clinicName ||  
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[6].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[6] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Health Care Provider Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||  
                      data.clinicName ||  
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Clinic Name',
                mapTo: 'contacts[6].clinicName',
                type: 'text',
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'contacts[6].address',
                type: 'text',
                style: {
                  width: '373px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'contacts[6].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'State',
                mapTo: 'contacts[6].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'contacts[6].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[6].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Fax Number',
                mapTo: 'contacts[6].faxNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Dentist Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[7].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[7] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Dentist Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||  
                      data.clinicName ||  
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[7].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[7] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Dentist Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||  
                      data.clinicName ||  
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Clinic Name',
                mapTo: 'contacts[7].clinicName',
                type: 'text',
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'contacts[7].address',
                type: 'text',
                style: {
                  width: '373px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'contacts[7].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'State',
                mapTo: 'contacts[7].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'contacts[7].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[7].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Fax Number',
                mapTo: 'contacts[7].faxNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Psychologist/Psychiatrist Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[8].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[8] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Psychologist/Psychiatrist Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||  
                      data.clinicName ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[8].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[8] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Psychologist/Psychiatrist Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||  
                      data.clinicName ||
                      data.address ||
                      data.city ||
                      data.state ||
                      data.zipCode ||
                      data.workPhoneNumber ||
                      data.faxNumber
                    ,
                    errors);
                }
              },
              {
                label: 'Clinic Name',
                mapTo: 'contacts[8].clinicName',
                type: 'text',
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Address',
                mapTo: 'contacts[8].address',
                type: 'text',
                style: {
                  width: '373px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'City',
                mapTo: 'contacts[8].city',
                type: 'text',
                maxLength: 40,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'State',
                mapTo: 'contacts[8].state',
                type: 'text',
                maxLength: 2,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Zip Code',
                mapTo: 'contacts[8].zipCode',
                type: 'text',
                maxLength: 10,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[8].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Fax Number',
                mapTo: 'contacts[8].faxNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
            ],
          },
        ],
      },
      {
        title: 'Other Health Care Contact Information',
        rows: [
          {
            cols: [
              {
                label: 'First Name',
                mapTo: 'contacts[9].firstName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[9] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Other Health Care Contact Information',
                    'First Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.lastName ||  
                      data.relationshipToClient ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                }
              },
              {
                label: 'Last Name',
                mapTo: 'contacts[9].lastName',
                type: 'text',
                maxLength: 20,
                style: {
                  width: '273px',
                },
                validation: (section, currentColumn, constructedData, currentColumnValue, errors) => {
                  let data = constructedData.contacts ? constructedData.contacts[9] : null;
                  return customValidator.validateDependantRequiredColumn(
                    'Other Health Care Contact Information',
                    'Last Name',
                    currentColumn,
                    currentColumnValue,
                    data,
                    (data) =>
                      data.firstName ||  
                      data.relationshipToClient ||
                      data.cellPhoneNumber ||
                      data.workPhoneNumber ||
                      data.email
                    ,
                    errors);
                }
              },
              {
                label: 'Relationship to Client',
                mapTo: 'contacts[9].relationshipToClient',
                type: 'text',
                maxLength: 50,
                style: {
                  width: '273px',
                },
              },
            ],
          },
          {
            cols: [
              {
                label: 'Cell Phone Number',
                mapTo: 'contacts[9].cellPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'Work Phone Number',
                mapTo: 'contacts[9].workPhoneNumber',
                type: 'tel',
                required: false,
                isInvalid: false,
                isPhoneNumber: true,
                maxLength: 30,
                style: {
                  width: '273px',
                },
              },
              {
                label: 'E-mail',
                mapTo: 'contacts[9].email',
                type: 'text',
                required: false,
                isInvalid: false,
                isEmail: true,
                maxLength: 200,
                style: {
                  width: '273px',
                },
              },
            ],
          },
        ],
      },
    ],
  };
};

export default healthModel;
